import script from "./RfidAssociateTagPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidAssociateTagPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidAssociateTagPage.vue?vue&type=style&index=0&id=7447a720&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7447a720"]])

export default __exports__